module.exports = __webpack_public_path__ + "static/img_rplanet-9c1279c145a9fd971c1a5dce004add8e.png";